import { render, staticRenderFns } from "./ModalDeleteContact.vue?vue&type=template&id=1151217c&scoped=true&"
import script from "./ModalDeleteContact.vue?vue&type=script&lang=js&"
export * from "./ModalDeleteContact.vue?vue&type=script&lang=js&"
import style0 from "./ModalDeleteContact.vue?vue&type=style&index=0&id=1151217c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1151217c",
  null
  
)

export default component.exports